import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateUser } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const teamRoute: Routes = [
  {
    path: 'teams',
    loadComponent: () => import('@team/pages/list/list.component').then(m => m.ListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateUser],
    data: {
      title: 'Verticais Tecnológicas',
      key: PageKey.TEAMS
    }
  }
];
